<template>
  <div class="t-lk-materials">
    <div class="t-lk-container">
      <lk-breadcrumbs-cmp :breadcrumbs="breadcrumbs"></lk-breadcrumbs-cmp>

      <div v-animation:bottom.delay class="t-lk-title-link t-lk-container-mobile t-lk-materials__title">
        <h1 class="t-lk-title t-lk-title-link__title">{{ title }}</h1>
        <router-link
          class="t-btn-green t-lk-materials__btn"
          :class="{ _active: $route.query.favorite }"
          :to="{
            name: $route.name,
            query: {
              ...$route.query,
              favorite: $route.query.favorite ? undefined : true,
              currentPage: undefined,
            },
          }"
        >
          {{ $route.query.favorite ? $root.staticText.lk.materialsAll : $root.staticText.lk.materialsFavorite }}
        </router-link>
      </div>

      <div v-animation:bottom.delay class="t-lk-materials__filter">
        <filter-cmp
          v-if="filter"
          :filter="filter"
          :name-btn="$root.staticText.lk.materialsFilterBtn"
          :obj-undefined="{ currentPage: undefined }"
          :white="true"
          :is-date="true"
          :is-date-left="false"
        >
        </filter-cmp>
      </div>

      <div class="t-lk-materials__container js-materials-white-label-id">
        <a
          v-animation:bottom.delay
          v-for="item in items"
          :href="item.link"
          download
          :key="'materials-item' + item.id"
          class="t-lk-materials-wl-id__item"
        >
          <div class="t-lk-materials-wl-id__img">
            <img v-if="item.img" :src="item.img" :alt="item.name" />
          </div>
          <div class="t-lk-materials-wl-id__wrap">
            <div class="t-lk-materials-wl-id__row">
              <div class="t-lk-materials-wl-id__name">{{ item.name }}</div>
              <div class="t-lk-materials__favorite" :class="{ _active: item.isFavorites }" @click.stop.prevent="toggleFavorite(item)">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M12.0002 1.2002C12.3047 1.2002 12.5828 1.37305 12.7176 1.6461L15.6216 7.52937L22.1159 8.47861C22.4172 8.52264 22.6673 8.73384 22.7612 9.02345C22.8551 9.31306 22.7765 9.63086 22.5584 9.84328L17.8598 14.4197L18.9687 20.885C19.0202 21.1851 18.8968 21.4885 18.6504 21.6674C18.404 21.8464 18.0774 21.87 17.8079 21.7283L12.0002 18.6741L6.19258 21.7283C5.92305 21.87 5.59641 21.8464 5.35003 21.6674C5.10365 21.4885 4.98025 21.1851 5.03173 20.885L6.1406 14.4197L1.44203 9.84328C1.22394 9.63086 1.14532 9.31306 1.23922 9.02345C1.33312 8.73384 1.58327 8.52264 1.88452 8.47861L8.37881 7.52937L11.2829 1.6461C11.4176 1.37305 11.6957 1.2002 12.0002 1.2002Z"
                    stroke="#C0C0CC"
                    stroke-width="1.6"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
            <div class="t-lk-materials-wl-id__bottom">
              <div class="t-file__row">
                <div class="t-file__type">{{ item.type }}</div>
                <div class="t-file__size">{{ item.size }}</div>
              </div>
              <div class="t-lk-materials-id-items__right">
                <span>{{ $root.staticText.lk.requestsDownload }}</span>
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M3.33301 13.333V14.1663C3.33301 14.8294 3.5964 15.4653 4.06524 15.9341C4.53408 16.4029 5.16997 16.6663 5.83301 16.6663H14.1663C14.8294 16.6663 15.4653 16.4029 15.9341 15.9341C16.4029 15.4653 16.6663 14.8294 16.6663 14.1663V13.333M13.333 9.99967L9.99967 13.333M9.99967 13.333L6.66634 9.99967M9.99967 13.333V3.33301"
                    stroke="#C0C0CC"
                    stroke-width="1.3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </div>
          </div>
        </a>
      </div>

      <pagination-cmp
        v-animation:bottom.delay
        v-if="pagination"
        :pagination="pagination"
        :name-current-page="'currentPage'"
        class="_lk"
      >
      </pagination-cmp>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import lkBreadcrumbs from '@components/lk/lk-breadcrumbs/lk-breadcrumbs'
import filter from '@components/lk/lk-filter/lk-filter'
import pagination from '@ui/pagination/pagination'
import onScrollAnimate from '@assets/js/scrollAnimate'
import { router } from '@src/routes'

export default {
  name: 'materials-white-label-id',
  data() {
    return {
      breadcrumbs: null,
      title: null,
      filter: null,
      items: [],
      pagination: null,
    }
  },
  components: {
    'filter-cmp': filter,
    'pagination-cmp': pagination,
    'lk-breadcrumbs-cmp': lkBreadcrumbs,
  },
  methods: {
    setData(data) {
      this.breadcrumbs = data.breadcrumbs
      this.banner = data.banner
      this.title = data.title
      this.filter = data.filter
      this.items = data.items
      this.pagination = data.pagination
    },
    toggleFavorite(item) {
      let url = 'lk/materials-white-label/addFavorite'

      if (item.isFavorites) {
        url = 'lk/materials-white-label/removeFavorite'
      }

      let fd = new FormData()
      fd.append('id', item.id)

      Vue.http
        .post(url, fd)
        .then(response => response.json())
        .then(data => {
          if (data.success) {
            item.isFavorites = !item.isFavorites
          }
        })
        .catch(() => {})
    },
  },
  beforeRouteUpdate(to, from, next) {
    let url =
      process.env.NODE_ENV !== 'production' ? 'lk/materialsWhiteLabelId.json' : to.path.substring(1).replace(router.history.base, '')

    this.$root.setDataAnimateFalse('.js-materials-white-label-id ')

    Vue.http.get(url, { params: to.query }).then(
      data => {
        this.setData(data.data)
        next()
        setTimeout(() => {
          onScrollAnimate()
        }, 500)
      },
      data => {
        if (data.status === 403) {
          next({ name: 'E403' })
        } else {
          next({ name: 'E404' })
        }
      }
    )
  },
  beforeRouteEnter(to, from, next) {
    let url =
      process.env.NODE_ENV !== 'production' ? 'lk/materialsWhiteLabelId.json' : to.path.substring(1).replace(router.history.base, '')

    Vue.http.get(url).then(
      data => {
        next(vm => vm.setData(data.data))
      },
      data => {
        if (data.status === 403) {
          next({ name: 'E403' })
        } else {
          next({ name: 'E404' })
        }
      }
    )
  },
}
</script>

<style lang="sass"></style>



// WEBPACK FOOTER //
// src/templates/pages/lk/materials/materials-white-label/id/index.vue